var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3341 2.8335C17.3341 2.37326 16.961 2.00016 16.5008 2.00016H9.00076L7.39512 0.394515C7.35605 0.355445 7.30306 0.333496 7.2478 0.333496H1.5013C1.04086 0.333496 0.667682 0.706909 0.667969 1.16735L0.675237 12.834C0.675524 13.294 1.04854 13.6668 1.50857 13.6668H16.5008C16.961 13.6668 17.3341 13.2937 17.3341 12.8335V2.8335ZM15.6674 12.0002H2.3341V3.66683H15.6674V12.0002Z",
    fill: "#697377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.a87b1724.svg";
export { ForwardRef as ReactComponent };